import api from '@/api/api'
import { Notification } from 'element-ui'

const state = {
    translations: {
        cms: [],
        frontend: []
    },
    translationsRender: {
        en: {
            navbarLogout: 'Logout',
        },
        mk: {
            navbarLogout: 'Logout',
        }
    }
}

const getters = {
    getTranslations (state) {
        return state.translations
    },
    getRenderTranslations (state) {
        return state.translationsRender
    }
}

const mutations = {
    SET_TRANSLATIONS (state, dist) {        
        if (dist.url === '?q=cms')
            state.translations.cms = dist.dist
        else
            state.translations.frontend = dist.dist
    },
    SET_RENDER_TRANSLATIONS (state, translations) {
        state.translationsRender = translations
    }
}

const actions = {
    async fetchRenderTranslations ({commit}) {
        let dist
        await api.fetchRenderTranslations()
        .then((res) => {
            dist = res.data.data            
        })
        .catch((err) => {

        })
        commit('SET_RENDER_TRANSLATIONS', dist)
    },
    async fetchTranslations ({commit}, url) {
        let dist
        await api.fetchTranslations(url)
        .then((res) => {
            dist = res.data.data            
        })
        .catch((err) => {

        })
        
        commit('SET_TRANSLATIONS', { dist: dist, url: url})
    },
    async updateTranslations ({commit}, request) {
         let dist
        await api.updateTranslations(request.id, request)
        .then((res) => {
            dist = res
        })
        .catch((err) => {
            dist = err
            Notification.error({
                title: 'Error',
                message: 'An error has occured'
            })
        })

        if (dist.status === 200) {
            Notification.success({
                title: 'Success',
                message: 'Translation successfully updated.'
            })
            return 'success'
        } else if (dist.status === 422) {            
            return dist.data.fields
        }
    },
    async addTranslation ({commit}, request) {
        
        let dist
        await api.saveTranslation(request)
        .then((res) => {
            dist = res
        })
        .catch((err) => {
            dist = err
            Notification.error({
                title: 'Error',
                message: 'An error has occured'
            })
        })        

        if (dist.status === 201) {
            Notification.success({
                title: 'Success',
                message: 'Translation successfully created.'
            })
            return 'success'
        } else if (dist.status === 422) {            
            return dist.data.fields
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/translations.js